import './App.css';
import Navbar from './components/Navbar';
import Contact from './components/Contact';
import About from './components/About';
import Projects from './components/Projects';
import Skills from './components/Skills';
//import Testimonials from './components/Testimonials';

function App() {
  return (
    <div className="App App-header">
      <main>
        <Navbar />
        <About />
        <Projects />
        <Skills />
        <Contact />
      </main>
    </div>
  );
}

export default App;
